
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin, getQueryString } from '@/common/ts/common';
import { vote, voteNum } from '../api';
import SlideVerify from '@/components/SlideVerify.vue';
import qs from 'qs';
import { namespace, State, Mutation } from 'vuex-class';

const fengShangModule = namespace('fengShang');
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
@Component({
  components: {
    SlideVerify,
  },
})
export default class VoteButton extends Vue {
  @fengShangModule.State('workType') workType: any;
  @fengShangModule.State('activityId') activityId: any;
  @fengShangModule.State('userId') userId: any;
  @fengShangModule.State('balance') balance: any;
  @fengShangModule.Mutation setBalance!: (num: number) => void;
  @Prop() voteId!: string | number;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  SlideShow = false;
  pointOut = false;
  unionId!: string | null;
  voteing: boolean = false;
  showLike = false;
  voteNum: any = 5;

  preVote() {
    // 在app内投票
    const token = window.gettoken && window.gettoken();
    if (!isWeiXin()) {
      if ((window.udid && !token) || token === 'null') {
        window.handleMessage('{"action":"mUserLogin","data":""}');
        return;
      }
      if (window.udid && token && token !== null) {
        this.showLike = true;
      } else {
        Dialog.confirm({
          title: '友情提示',
          message: '请在微信或者上游新闻App进行投票',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
          lockScroll: false,
        })
          .then(() => {
            window.location.href = this.downLoadUrl;
          })
          .catch(() => {
            if (isWeiXin() === true) {
              this.pointOut = true;
            } else {
              window.location.href =
                'shangyounews://{"dt":"7","url":"' +
                document.location.href +
                '"}';
            }
          });
      }
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请在微信或者上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
        lockScroll: false,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
  startVote() {
    // 输入的数字大于最大限制票数
    if (this.voteNum > this.balance) {
      Toast.fail('您的金币已不足，请先充值！');
      setTimeout(() => {
        this.$router.push('user/top-up');
      }, 1500);
      return;
    }
    if (this.voteing) {
      console.log('上次投票还在请求中');
      Toast('投票太过频繁');
      return;
    }
    this.voteing = true;
    const data = {
      id: this.voteId,
      num: this.voteNum,
      workType: this.workType,
      act_id: this.activityId,
      udid: window.udid,
      appkey: window.appkey,
    };
    vote(data).then((result: any) => this.successVote(result));
  }
  fSlideData(res: object) {
    this.SlideShow = false;
    if (window.udid) {
      const data = {
        id: this.voteId,
        num: this.voteNum,
        workType: this.workType,
        act_id: this.activityId,
        udid: window.udid,
        appkey: window.appkey,
      };
      const lastData = Object.assign(res, data);
      vote(lastData).then((result: any) => this.successVote(result));
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
  async successVote(res: any) {
    this.voteing = false;
    if (res.code === 200) {
      Toast({
        type: 'success',
        duration: 1200,
        message: res.msg,
      });
      this.$emit('votSuccess', { num: res.data, id: this.voteId });
      // 余额
      const balance: any = await voteNum(this.activityId);
      if (balance.code === 200) {
        this.setBalance(balance.data);
      }
    } else {
      Toast.fail(res.msg);
    }
  }
  testInput(e: any) {
    const key = e.data || '';
    if (key === '.') {
      e.preventDefault();
    }
  }
}
